import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {
  IonContent,
  IonTextarea,
  ModalController,
  ViewDidEnter,
  ViewWillEnter,
} from '@ionic/angular';
import { Subscription } from 'centrifuge';
import { log } from 'console';
import { WebSocketSubject } from 'rxjs/webSocket';
import { ChatHeader, ChatLogModel } from 'src/app/models/chat.model';
import { HotSupportChatStatus } from 'src/app/models/hot-support-chat-status';
import { NotificationModel } from 'src/app/models/notification.model';
import { RequestHeaderModel } from 'src/app/models/request-header.model';
import { SurveyResearchHeader } from 'src/app/models/survey-research_header';
import { AuthService } from 'src/app/services/auth.service';
import { CentrifugeService } from 'src/app/services/centrifuge.service';
import { ChatService } from 'src/app/services/chat.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { RequestService } from 'src/app/services/request.service';
import { SurveyService } from 'src/app/services/survey.service';
import { ToastMachineService } from 'src/app/services/toast-machine.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent
  implements OnInit, OnDestroy, ViewDidEnter, ViewWillEnter
{
  @ViewChild('content') content: IonContent;

  @Input() header: ChatHeader;
  @Input() live: boolean;

  records: ChatLogModel[] = [];

  request: RequestHeaderModel = null;

  webSocket: WebSocketSubject<ChatLogModel> = null;
  chatLogSub: Subscription;

  requestDetail = false;
  processing = false;

  translateTexts = [];
  textTranslated: boolean[] = [];
  showSuccessIcon: boolean[] = [];

  isMultipleLang = false;
  constructor(
    private mdlCtrl: ModalController,
    private chatServ: ChatService,
    public authServ: AuthService,
    private route: ActivatedRoute,
    private requestServ: RequestService,
    private http: HttpClient,
    public surveyServ: SurveyService,
    private modalServ: ModalMakerService,
    private chd: ChangeDetectorRef,
    public dataServ: DataService,
    private titleService: Title,
    private centrifugeServ: CentrifugeService,
    private location: Location,
    private navCtrl: NavController // NavController ekleyelim
  ) {}

  ionViewDidEnter() {
    setTimeout(() => {
      this.content.scrollToBottom(300);
    }, 300);
  }

  async ngOnInit() {
    // Route'tan live değerini al
    const route = this.route ?? new ActivatedRoute();
    route.data.subscribe((data) => {
      if (data && data.live !== undefined) {
        this.live = data.live;
      }
    });

    if (!this.live) {
      this.records = await this.chatServ.getChatLog(this.header.id);
      this.chatLogSub = this.centrifugeServ.subscribeToChannel(
        'request/' + this.header.id
      );
      this.chatLogSub.on('publication', (message) => {
        this.records.push(message.data);
        setTimeout(() => {
          this.content.scrollToBottom(300);
        }, 150);
      });
      this.chatLogSub.subscribe();
      this.request = await this.requestServ.getRequestById(this.header.id);
    } else {
      this.records = await this.chatServ.getLiveSupportLog(
        this.authServ.tokenForm.id
      );
      this.authServ.profile.chat_badge = 0;

      this.chatLogSub = this.centrifugeServ.subscribeToChannel(
        'hot_support/' + this.authServ.tokenForm.id
      );
      this.chatLogSub.on('publication', (message) => {
        this.records.push(message.data);
        setTimeout(() => {
          this.content.scrollToBottom(300);
        }, 150);
      });
      this.chatLogSub.subscribe();

      const chatStatus = new HotSupportChatStatus();
      chatStatus.type = 'HotSupport';
      chatStatus.is_online = true;
      this.chatServ.postChatStatus(this.authServ.profile.id, chatStatus);
      if (this.dataServ.rData?.languages?.length > 1) {
        this.isMultipleLang = true;
      }
    }

    if (this.header?.id) {
      await this.surveyServ.getSurveyByRequestId(this.header?.id);
    }
  }

  ionViewWillEnter(): void {
    this.titleService.setTitle('Live Chat');
  }

  ngOnDestroy() {
    this.titleService.setTitle('My Messages');

    const chatStatus = new HotSupportChatStatus();
    chatStatus.type = 'HotSupport';
    chatStatus.is_online = false;
    this.chatServ.postChatStatus(this.authServ.profile.id, chatStatus);

    this.chatLogSub.unsubscribe();
    this.chatLogSub.removeAllListeners();
  }

  // Smooth geçiş için NavController kullanalım
  async goBack() {
    // Modal kontrolü (popup olarak açılmışsa)
    try {
      await this.mdlCtrl.dismiss();
      return; // Modal kapandıysa işlemi tamamla
    } catch (err) {
      // Modal olmadığı durumda smooth geçiş için NavController kullanalım
      this.navCtrl.back();
      // Alternatif: this.navCtrl.navigateBack('/tabs/home'); gibi spesifik bir rota belirtebilirsiniz
    }
  }

  async survey(surveyMessage: NotificationModel) {
    try {
      this.modalServ.survey(surveyMessage, 'notification');
      this.chd.detectChanges();
    } catch (error) {}
  }

  async postMessage(textarea: IonTextarea) {
    this.processing = true;

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    const MSG = new ChatLogModel(
      this.live ? this.authServ.tokenForm.id : this.header.id,
      textarea.value.replace(/(\r\n|\n|\r)/gm, ''),
      this.authServ.profile
    );

    try {
      if (this.live) {
        await this.chatServ.postLiveSupportMessage(
          this.authServ.tokenForm.id,
          MSG
        );
      } else {
        await this.chatServ.postChatMessage(MSG);
      }
      textarea.value = null;
    } catch {}

    this.processing = false;
  }

  translateThisMessage(index: number) {
    if (this.translateTexts[index]) {
      this.textTranslated[index] = !this.textTranslated[index];
      return;
    }
    const text = this.records[index].message;
    const bearerToken = localStorage.getItem('token');
    const locale = localStorage.getItem('userLang');

    this.http
      .post(
        environment.apiURL +
          '/text_detect?text=' +
          text +
          '&target_language=' +
          locale,
        {
          observe: 'body',
          responseType: 'json',
        },
        {
          headers: new HttpHeaders({
            Authorization: 'Bearer ' + bearerToken,
          }),
        }
      )
      .subscribe((data: string) => {
        if (data != null) {
          this.textTranslated[index] = true;
          this.translateTexts[index] = data;

          this.showSuccessIcon[index] = true;
          setTimeout(() => {
            this.showSuccessIcon[index] = false;
          }, 1000);
        } else {
          this.textTranslated[index] = false;
          this.showSuccessIcon[index] = true;
          setTimeout(() => {
            this.showSuccessIcon[index] = false;
          }, 1000);
        }
      });
  }
}
